import { useEffect, useState } from 'react';
import { getDashboardKpis, type DashboardKpis } from '../../api';

// Simpel module-level cache så de 4 KPI-widgets ikke hver fetcher samme data.
// Cache udløber efter 30 sekunder så tal opdateres ved naturlig genmount.
let cachedPromise: Promise<DashboardKpis> | null = null;
let cachedAt = 0;
const TTL_MS = 30_000;

export function useDashboardKpis() {
  const [data, setData] = useState<DashboardKpis | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const now = Date.now();
    if (!cachedPromise || now - cachedAt > TTL_MS) {
      cachedPromise = getDashboardKpis();
      cachedAt = now;
    }
    cachedPromise
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  return { data, loading, error };
}
